module.exports = __webpack_public_path__ + "assets/img/kv-85abf21a.jpg";